(async () => {
  const { showElement, hideElement } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('announcement-bar', class extends baseComponent.default {
    elements = {
      buttonClose: '[data-dismiss]',
      cycleItems: '*[data-ab-cycle-item]'
    }

    render() {
      if (this.hasAttribute('dismissible')) {
        this._useDismiss();
      }
      if (this.$cycleItems && this.$cycleItems.length > 1) {
        this._initCycle();
      }
    };

    _useDismiss() {
      this.$buttonClose.addEventListener('click', this._closeBar.bind(this), { once: true });
      const isHidden = window.sessionStorage.getItem('hideAnnouncement');
      if (!isHidden) showElement(this);
    };

    _closeBar() {
      window.sessionStorage.setItem('hideAnnouncement', 'true');
      hideElement(this);
    }

    _initCycle() {
      const items = this.$cycleItems;
      const interval = parseInt(this.dataset.interval, 10) || 4000;
      let index = 0;

      setInterval(() => {
        const current = items[index];
        current.classList.remove('!active');
        current.classList.add('@leaving');

        index = (index + 1) % items.length;
        items[index].classList.add('!active');

        setTimeout(() => {
          current.classList.remove('@leaving');
        }, 420);
      }, interval);
    }
  });
})();
